<template>
  <div role="tablist" aria-multiselectable="true">
    <FaqItem
      v-for="faq in faqs"
      :key="faq.id"
      :faq="faq"
      :activeItem="activeItem"
      :isTransitioning="isTransitioning"
      :small="small"
      @open="onItemOpen(faq.id)"
      @close="onItemClose(faq.id)"
      @transitionchanged="setTransition"
    />
  </div>
</template>

<script>
import FaqItem from "./Faq/Item";

export default {
  name: "faq-wrapper",
  props: {
    faqs: Array,
    small: Boolean
  },
  components: {
    FaqItem
  },
  data() {
    return {
      activeItem: null,
      isTransitioning: false
    };
  },
  methods: {
    onItemOpen(id) {
      this.activeItem = id;
    },
    onItemClose(id) {
      if (this.activeItem === id) {
        this.activeItem = null;
      }
    },
    setTransition(result) {
      this.isTransitioning = result;
    }
  }
};
</script>
